import { useFlags } from 'launchdarkly-react-client-sdk'

import useAuth from 'hooks/use-auth'
import {
  useAlfiClients,
  useInfraClients,
  useK8sClients
} from 'hooks/use-clients'
import { useGameDays } from 'hooks/use-gamedays'
import { useServices } from 'hooks/use-services'

export default function useLongRunningApiData(enabled = true): void {
  const { createGamedays: isCreateGameDaysEnabled } = useFlags()
  const { hasReliabilityManagement, isPaywallActive } = useAuth()
  const { companyIsAlfiEnabled: isAlfiEnabled } = useAuth()

  const allEnabled = enabled && !isPaywallActive

  useGameDays(allEnabled && isCreateGameDaysEnabled)
  useServices(allEnabled && hasReliabilityManagement)
  useInfraClients({ enabled: allEnabled })
  useK8sClients({ enabled: allEnabled })
  useAlfiClients({ enabled: allEnabled && isAlfiEnabled })
}
